(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42595,65250],{

/***/ 42595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IForkLiftWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
;// CONCATENATED MODULE: ./src/components/iforklift/logo/index.tsx


function PointOfSaleCostLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "362",
        height: "55",
        fill: "none",
        viewBox: "0 0 362 55",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M73.6 52.5h-8.2V9.7h28.9v7.5H73.6v12.2h16.1v7.1H73.6v16zM102.3 51.1c-2.6-1.5-4.6-3.5-6.1-6.1-1.5-2.5-2.2-5.3-2.2-8.4 0-3.1.7-5.9 2.2-8.5 1.5-2.6 3.5-4.6 6.1-6.1 2.6-1.5 5.4-2.2 8.5-2.2 3.1 0 5.9.8 8.5 2.3 2.6 1.5 4.6 3.5 6.1 6.1 1.5 2.6 2.2 5.4 2.2 8.4s-.7 5.8-2.2 8.4c-1.5 2.6-3.5 4.6-6.1 6.1-2.6 1.5-5.4 2.2-8.6 2.2-3 .1-5.8-.7-8.4-2.2zm13.2-6.3c1.4-.8 2.5-2 3.3-3.4.8-1.4 1.2-3 1.2-4.8 0-1.8-.4-3.4-1.2-4.8-.8-1.4-1.9-2.6-3.3-3.4-1.4-.8-2.9-1.2-4.6-1.2-1.7 0-3.2.4-4.6 1.2-1.4.8-2.5 2-3.3 3.4-.8 1.4-1.2 3-1.2 4.8 0 1.8.4 3.4 1.2 4.8.8 1.4 1.9 2.6 3.3 3.4 1.4.8 2.9 1.2 4.6 1.2 1.7.1 3.2-.3 4.6-1.2zM152.7 20.6c1.3.4 2.5 1 3.7 1.9l-3.4 6.3c-1.6-1.1-3.2-1.7-4.9-1.7-1.2 0-2.3.4-3.3 1.1-1.1.7-1.9 1.7-2.6 3-.7 1.3-1 2.8-1.1 4.6v16.7h-7.8V20.6h6.7l.5 4.3c.9-1.6 2.1-2.8 3.5-3.7 1.5-.9 3.1-1.3 4.9-1.3 1.3 0 2.5.2 3.8.7zM191.7 52.5h-9.2l-10-13.5-4.8 5.1v8.4H160V6.9h7.8v27.6l12.5-13.9h9.9l-12.4 13 13.9 18.9zM203.9 52.5h-7.7V6.9h7.7v45.6zM212 13.5c-.7-.4-1.3-1-1.7-1.7-.4-.7-.6-1.5-.6-2.3 0-.8.2-1.5.6-2.3.4-.7 1-1.3 1.7-1.8.7-.4 1.6-.7 2.5-.7.9 0 1.8.2 2.5.7.7.4 1.3 1 1.7 1.8.4.7.6 1.5.6 2.3 0 .8-.2 1.5-.6 2.3-.4.7-1 1.3-1.7 1.7-.7.4-1.6.7-2.5.7-.9 0-1.8-.3-2.5-.7zm6.3 39h-7.8V20.6h7.8v31.9zM228.6 52.5V27.7h-4.2v-7.2h4.2v-3.9c0-7.3 4-10.9 12.1-10.9h2.5v6.8c-1.1 0-1.8-.1-2.1-.1-1.6 0-2.8.4-3.5 1.2-.8.8-1.1 2.1-1.1 3.7v3h6.7v7.2h-6.6v25h-8zM258.7 52.5h-7.8V27.7h-4.6v-7.2h4.5v-7.6l7.8-1.9v9.5h7v7.2h-7v24.8h.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFC600",
                d: "M268.9 52.6c-.7-.4-1.3-1-1.7-1.6-.4-.7-.6-1.4-.6-2.3 0-.9.2-1.6.6-2.3.4-.7 1-1.2 1.7-1.6.7-.4 1.6-.6 2.5-.6.9 0 1.7.2 2.5.6.7.4 1.3 1 1.7 1.6.4.7.6 1.4.6 2.3 0 .8-.2 1.6-.6 2.3-.4.7-1 1.2-1.7 1.6-.7.4-1.6.6-2.5.6-.9 0-1.7-.2-2.5-.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M286.8 51.6c-1.7-1-3-2.3-3.9-4-.9-1.7-1.4-3.5-1.4-5.5s.5-3.8 1.4-5.5c1-1.7 2.3-3 3.9-4 1.7-1 3.5-1.5 5.6-1.5 1.5 0 2.9.3 4.2.8 1.3.5 2.4 1.2 3.4 2.1l-2.6 3.7c-.7-.6-1.5-1.1-2.2-1.4-.8-.3-1.6-.5-2.6-.5-1.1 0-2.1.3-3.1.8-.9.6-1.7 1.3-2.2 2.3-.6 1-.8 2.1-.8 3.2 0 1.2.3 2.2.8 3.2.6 1 1.3 1.7 2.2 2.3.9.6 2 .8 3 .8.9 0 1.8-.2 2.6-.5s1.5-.8 2.2-1.4l2.5 3.6c-1 .9-2.1 1.6-3.4 2.1-1.3.5-2.7.8-4.2.8-1.9.1-3.8-.4-5.4-1.4zM307.4 51.6c-1.7-1-3-2.3-4-4-1-1.7-1.5-3.5-1.5-5.5s.5-3.9 1.5-5.6c1-1.7 2.3-3 4-4 1.7-1 3.6-1.5 5.6-1.5 2 0 3.9.5 5.6 1.5 1.7 1 3 2.3 4 4 1 1.7 1.5 3.5 1.5 5.6 0 2-.5 3.8-1.5 5.5-1 1.7-2.3 3-4 4-1.7 1-3.6 1.5-5.6 1.5-2 0-3.9-.5-5.6-1.5zm8.7-4.1c.9-.5 1.6-1.3 2.2-2.2.5-.9.8-2 .8-3.1 0-1.2-.3-2.2-.8-3.2-.5-.9-1.3-1.7-2.2-2.2-.9-.5-1.9-.8-3-.8s-2.1.3-3 .8c-.9.5-1.6 1.3-2.2 2.2-.5.9-.8 2-.8 3.2 0 1.2.3 2.2.8 3.2.5.9 1.3 1.7 2.2 2.2.9.5 1.9.8 3 .8s2-.4 3-.9zM357.6 32c1.2.7 2.1 1.7 2.7 3 .6 1.3 1 2.9 1 4.8v12.7h-5.1v-12c0-1.5-.4-2.7-1.1-3.5-.7-.8-1.7-1.3-2.9-1.3-.8 0-1.6.2-2.3.7-.7.5-1.2 1.1-1.6 1.8-.4.7-.6 1.6-.6 2.5v11.8h-5.1v-12c0-1.5-.4-2.7-1.1-3.5-.7-.8-1.7-1.3-2.9-1.3-.8 0-1.6.2-2.3.7-.7.5-1.2 1.1-1.6 1.8-.4.8-.6 1.6-.6 2.5v11.8H329v-21h4.4l.3 2.2c.8-.9 1.8-1.5 2.8-2 1.1-.5 2.2-.7 3.4-.7 1.5 0 2.8.3 3.9.9 1.1.6 2 1.5 2.7 2.7.8-1.1 1.8-2 3-2.7 1.3-.6 2.6-1 3.9-1 1.7.1 3 .5 4.2 1.1zM31.2 32.9l2.3-1.4.3.6-.7.6 1 1.3-1.4 1.1-.4-1.9-.8.2-.3-.5zM12.7 28.5l-1.2-10.9-.8.1 1.2 10.9.8-.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M11.9 29.7l7.9.6 1.3-2.1h-9.3l.1 1.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M12.6 28.4l9.1.1s1.7-2 .1-2.3c-2.9-.6-7.8.3-7.8.3s.3-3.9.1-6.1c-.1-2.2-.6-4.2-1.6-4.9-.8-.6-1.3.1-1.3.4.4 3.3 1.4 12.5 1.4 12.5zM26.1 22.5c-.1.2 0 .4.2.6.2.1.5.1.6-.1l2.9-4.9c.1-.2 0-.4-.2-.6-.2-.1-.5-.1-.6.1l-2.9 4.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M27.1 20.1c-.1.2-.1.4.1.5l6.4 3.8c.2.1.4 0 .5-.2l.3-.5c.1-.2.1-.4-.1-.5l-6.4-3.8c-.2-.1-.4 0-.5.2l-.3.5zM45.4 41.4V0h2.8v52.7h-2.8v-1.6c.9-1.4 1.4-3.1 1.4-4.9 0-1.7-.5-3.4-1.4-4.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M43.1 30.4l3.7-.7-.3-1.4-3.7.7.3 1.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M38.5 31.5l4.8-.9-.4-1.9-4.8.8.4 2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M5 3.4v-.1c0-.2 0-.6.1-1.1.1-.5.3-1 .8-1.4.4-.3.9-.5 1.2-.6.4-.1.7-.1 1-.1h.2l10.4.1s.8 0 1.9.1c1 .1 2.3.2 3.2.7 3.3 1.6 4.4 3.9 4.6 4.3l19.8 37.6-1.4.7-.4.1c-.6-2.2-2.1-4.1-4-5.3l.4-2.3L27 5.9c0-.1-.9-2.2-3.8-3.5-.5-.3-1.7-.5-2.6-.5-.5 0-.9-.1-1.2-.1h-.5L8.4 1.7h-.1c-.1 0-.4 0-.6.1-.2.1-.4.1-.6.3-.1 0-.2.3-.2.5-.1.3-.1.6-.1.8v.1L5.7 31.1 4 30.9 5 3.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M29 46.3c0 4.7 3.8 8.5 8.5 8.5S46 51 46 46.3s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5zm3.5 0c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFC600",
                d: "M37.5 44.5c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8-1.8-.8-1.8-1.8.8-1.8 1.8-1.8zM38.5 43.6c-.3.2-.6.1-.8-.2-.2-.3-.1-.6.2-.8.3-.2.6-.1.8.2.2.3.1.6-.2.8zM40.1 45.1c.2-.3.5-.4.8-.2.3.2.4.5.2.8-.2.3-.5.4-.8.2-.2-.2-.3-.6-.2-.8zM39.9 48c.3 0 .6.3.6.6s-.3.6-.6.6-.6-.3-.6-.6.3-.6.6-.6zM36.4 49c.3-.2.6-.1.8.2.2.3.1.6-.2.8-.3.2-.6.1-.8-.2-.1-.3-.1-.6.2-.8zM34.6 46.7c.3.2.4.5.2.8-.2.3-.5.4-.8.2-.3-.2-.4-.5-.2-.8.2-.2.5-.3.8-.2zM34.5 44c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.3-.6-.6zM3.1 34.4c0-1.7 1.4-3.1 3.1-3.1h10.3c1.7 0 3.1 1.4 3.1 3.1v9.8c0 1.7-1.4 3.1-3.1 3.1h-2.1c0-.1 0-.2-.1-.3v-.1c0-.1 0-.1-.1-.2v-.1c0-.1 0-.1-.1-.2v-.1c0-.1-.1-.1-.1-.2V46c0-.1-.1-.2-.1-.2v-.1c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1l-.1-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.2l-.1-.1-.2-.2s0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.2-.2-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1l-.1-.1s-.1 0-.1-.1c-.1-.1-.2-.1-.3-.2H11l-.1-.1h-.1s-.1 0-.1-.1h-.1c-.1 0-.1 0-.2-.1h-.1c-.1-.1-.3-.1-.4-.2-.1 0-.1 0-.2-.1-.6-.2-1.3-.3-2-.3-1.9 0-3.6.8-4.8 2.1v-9.6h.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint0_linear_493_156)",
                d: "M3.1 34.4c0-1.7 1.4-3.1 3.1-3.1h10.3c1.7 0 3.1 1.4 3.1 3.1v9.8c0 1.7-1.4 3.1-3.1 3.1h-2.1c0-.1 0-.2-.1-.3v-.1c0-.1 0-.1-.1-.2v-.1c0-.1 0-.1-.1-.2v-.1c0-.1-.1-.1-.1-.2V46c0-.1-.1-.2-.1-.2v-.1c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1l-.1-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.2l-.1-.1-.2-.2s0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.2-.2-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1l-.1-.1s-.1 0-.1-.1c-.1-.1-.2-.1-.3-.2H11l-.1-.1h-.1s-.1 0-.1-.1h-.1c-.1 0-.1 0-.2-.1h-.1c-.1-.1-.3-.1-.4-.2-.1 0-.1 0-.2-.1-.6-.2-1.3-.3-2-.3-1.9 0-3.6.8-4.8 2.1v-9.6h.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M2.2 49c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8-3.2 0-5.8 2.6-5.8 5.8zm2.3 0c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4c-1.8 0-3.4-1.5-3.4-3.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFC600",
                d: "M7.9 47.8c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2zM8.7 47.2c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.1.1 0 .3-.1.5zM9.8 48.2c.1-.2.3-.2.5-.1s.2.3.1.5-.3.2-.5.1-.2-.3-.1-.5zM9.6 50.2c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4zM7.2 50.9c.2-.1.4 0 .5.1.1.2 0 .4-.1.5-.2.1-.4 0-.5-.1-.1-.2-.1-.4.1-.5zM6 49.3c.2.1.2.3.1.5s-.3.2-.5.1-.2-.3-.1-.5c.1-.1.3-.2.5-.1zM5.9 47.5c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4c-.2-.1-.4-.2-.4-.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFC600",
                d: "M0 33.3v11c0 1.2.6 2.3 1.4 3 .3-1.1.9-2.1 1.7-2.9v-10c0-1.7 1.4-3.1 3.1-3.1h10.3c1.7 0 3.1 1.4 3.1 3.1v9.8c0 1.7-1.4 3.1-3.1 3.1h-2.1c0 .1 0 .2.1.2V48.2l13.7.1c-.1-.6-.2-1.3-.2-2 0-5.2 4.2-9.3 9.3-9.3 2.3 0 4.4.8 6.1 2.2v-4l-5-9.2-2.5-4.6c-1.5-.4-3.2-.9-3.6-.8-.9.1-2.6 2.7-2.3 3.6.2.8 4.4 2.8 4.4 6.7v.4c-.2 1.8-1.7 3.2-3.6 3.2h-9.1v-1.2c0-2.1-1.7-3.8-3.8-3.8H3.8c-2.1 0-3.8 1.7-3.8 3.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M13.5 17.1c.6-2.9 1.6-4.9 2.9-5.4h.1c-.6-.6-1-1.6-.9-2.7 0-.2 0-.5.1-.7h-.4c.1-1.8 1.6-3.3 3.2-3.2 1.2.1 2.3 1 2.6 2.2.1.3.9.8 1.3 1.1h-1.3c0 .3.1.6 0 .8-.1 1.4-.9 2.5-1.9 2.9.2.1.3.2.4.4l.1.1 2.8 3.8 4.8 1.2-.1.2h1c.2.1.3.2.5.3.4.2 0 .6.5 1.1.3.3-.6 1.6-1.2 1.5-.3 0-.6-.4-1-.6-.2-.1-.3-.3-.6-.4l-.2.4s-3.8-.7-5-1.3c-.3-.2-.8-.5-1.3-.9-.2 1.8-.6 4.1-.6 4.1s4.3.7 5.6 1.4c1.5.9 5.2 7.6 5.2 7.6s3.7-.9 3.9.1c.2.7-5.1 3.1-5.1 3.1l-1.2-1.6-1.1.6s-3.5-6.1-3.9-6.5c-.7-.5-8.1.8-9.2-.5-1.1-1.6-.6-6.1 0-9.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint1_linear_493_156)",
                d: "M42.5 38.4l.4-2.9-7.5-13-2.5-.6c-.2-.1-1.3.5-1.2.7l10.8 15.8z",
                opacity: "0.54"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#232323",
                d: "M52.9 13c-.7-.4-1.3-1-1.7-1.7-.4-.7-.6-1.5-.6-2.3 0-.8.2-1.5.6-2.3.4-.7 1-1.3 1.7-1.8.7-.4 1.6-.7 2.5-.7.9 0 1.8.2 2.5.7.7.4 1.3 1 1.7 1.8.4.7.6 1.5.6 2.3 0 .8-.2 1.5-.6 2.3-.4.7-1 1.3-1.7 1.7-.7.4-1.6.7-2.5.7-.9 0-1.8-.3-2.5-.7zM59.3 47.2h-7.8V16.4h7.8v30.8zM59.3 50H47.2v2.8h12.1V50z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_493_156",
                        x1: "19.608",
                        x2: "3.094",
                        y1: "39.258",
                        y2: "39.258",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#fff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFDF00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_493_156",
                        x1: "39.175",
                        x2: "30.291",
                        y1: "29.206",
                        y2: "34.335",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFDF00"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.004",
                                stopColor: "#FFE009",
                                stopOpacity: "0.993"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.027",
                                stopColor: "#FFE637",
                                stopOpacity: "0.952"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.054",
                                stopColor: "#FFEB62",
                                stopOpacity: "0.907"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.082",
                                stopColor: "#FFF088",
                                stopOpacity: "0.858"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.112",
                                stopColor: "#FFF4A8",
                                stopOpacity: "0.805"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.146",
                                stopColor: "#FFF8C4",
                                stopOpacity: "0.746"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.184",
                                stopColor: "#FFFADA",
                                stopOpacity: "0.68"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.229",
                                stopColor: "#FFFCEB",
                                stopOpacity: "0.603"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.283",
                                stopColor: "#FFFEF6",
                                stopOpacity: "0.507"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.361",
                                stopColor: "#FFFFFD",
                                stopOpacity: "0.373"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.575",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/iForkLiftVariables.module.scss
var iForkLiftVariables_module = __webpack_require__(46595);
var iForkLiftVariables_module_default = /*#__PURE__*/__webpack_require__.n(iForkLiftVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/iForkLiftWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function IForkLiftWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Forklifts",
                    domain: "IForkLift.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Forklifts",
                    domain: "IForkLift.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "TOP FORKLIFT COMPANIES",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointOfSaleCostLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        textColor: (iForkLiftVariables_module_default()).youngNight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 46595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"citrusSplash":"#ffc600","youngNight":"#232323"};

/***/ })

}]);